import { NAME } from './constants';
import { router } from './router';
import { apiProvider } from './api';

export const NewCdbLog = {
	name: NAME,
	router,
	apiProvider,
};
